<template>
  <div>
    <form v-if="phoneValidate">
      <h2 class="form__title">Регистрация <span class="form__title-part-separated">Шаг 2 из 6</span></h2>
      <h3 class="form__subtitle">Подтверждение телефона</h3>
      <div class="form__description">
        <p>
          Для продолжения регистрации позвоните с&nbsp;номера <b class="_g-text-no-wrap">{{ phone }}</b>
          по&nbsp;номеру, указанному ниже. Звонок бесплатный.
          Переход произойдет автоматически в&nbsp;течение пяти секунд после звонка.
        </p>

        <h2>
          <a class="form__link" :href="`tel:+${phoneValidate.data.callDetails.confirmationNumber}`">
            {{ phoneValidate.data.callDetails.confirmationNumber | VMask('+# (###) ###-##-##') }}
          </a>
        </h2>

        <p>
          Обратите внимание, что&nbsp;аккаунт с&nbsp;неподтвержденным
          номером телефона будет удален в&nbsp;течение <b>24&nbsp;часов.</b>
        </p>
      </div>

      <div class="form-row form-row_mobile-wrap form__actions">
        <button class="form__submit button button__lg button__blue"
                type="submit"
                :disabled="loading || resendTimeLeft > 0"
                @click="verifyPhone"
        >
          Запросить другой номер <span v-if="resendTimeLeft > 0">через&nbsp;<b>{{ timeFormatted }}&nbsp;сек</b></span>
        </button>
      </div>

      <!--
        <router-link v-if="!$store.state.currentUser" :to="{name: 'login'}" class="form__link">Войти</router-link>
        <router-link :to="{ name: 'feedback' }" class="form__link">Написать нам</router-link>
      -->
      <div class="form-row form-row_align-center">
        <a class="button button__lg button__blue" @click.prevent="openModalChangePhone">Изменить мой номер</a>
      </div>

      <div class="form-row form-row_align-center">
        <p>Если звонок не&nbsp;проходит, вы можете запросить другой номер</p>
      </div>

      <div class="form-row form-row_align-center">
        <delete-questionnaire-btn/>
      </div>
    </form>

    <sign-up-step-phone-change-modal
      :opened="modalChangePhoneOpened"
      :phone="phone"
      @close="closeModalChangePhone"
      @change-phone="handlePhoneChange"
    />
  </div>
</template>

<script>
import api from "../services/api";
import SignUpStepPhoneChangeModal from "./SignUpStepPhoneChangeModal.vue";

const REFRESH_TIMEOUT = 120

export default {
  name: "SignUpStepPhone",
  components: {SignUpStepPhoneChangeModal},
  props: {
    phone: {type: String}
  },
  data() {
    return {
      phoneValidate: null,
      resendTimeLeft: 0,
      checkInterval: null,
      loading: false,
      modalChangePhoneOpened: false,
    }
  },
  computed: {
    timeFormatted() {
      const minutes = Math.floor(this.resendTimeLeft / 60);
      const seconds = this.resendTimeLeft % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  methods: {
    async phoneByCallCheck() {
      try {
        if (this.resendTimeLeft % 5 === 0) {
          const callId = await api.verifyPhoneByCallCheck(this.phoneValidate?.data?.callDetails?.callId);
          if (callId) {
            this.stopTimer();
            this.$emit('complete');
            this.$store.dispatch('hideErrorsBag');
          }
        }

        if (this.resendTimeLeft > 0) {
          this.resendTimeLeft--;
        } else {
          this.stopTimer();
        }
      } catch (e) {
        this.$store.dispatch('setErrors', e);
      }
    },
    async verifyPhone() {
      if (this.loading || this.resendTimeLeft > 0) {
        return
      }
      this.loading = true

      try {
        this.phoneValidate = await api.verifyPhoneByCall(String(this.phone.replace(/\D/g, "")));
        this.startTimer();
      } finally {
        this.loading = false
      }
    },
    startTimer() {
      this.stopTimer();
      this.resendTimeLeft = REFRESH_TIMEOUT;
      this.checkInterval = setInterval(this.phoneByCallCheck, 1000);
    },
    stopTimer() {
      this.resendTimeLeft = 0;
      clearInterval(this.checkInterval);
    },
    goBack() {
      this.$emit('back');
    },
    openModalChangePhone() {
      this.modalChangePhoneOpened = true;
    },
    closeModalChangePhone() {
      this.modalChangePhoneOpened = false;
    },
    handlePhoneChange(phone) {
      this.$emit('change-phone', phone);
    }
  },
  async created() {
    await this.verifyPhone();
  },
  beforeDestroy() {
    this.stopTimer();
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/base/_settings.scss";
.form__actions {
  gap: 10px;
  @include mobile {
    text-align: center;
  }
}
.form__nav-first {
  @include mobile {
    order: 1;
  }
}
.form__submit {
  margin: 0 auto;
}
</style>
